import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Content from './components/Content';
import Contact from './components/Contact';
import Footer from './components/Footer';
import NotFound from './components/NotFound';
import ScrollToTop from './components/ScrollToTop';
import Villanyszereles from './components/Villanyszereles';
import Napelem from './components/Napelem';
import Klima from './components/Klima';
import BerendezesGyartas from './components/BerendezesGyartas';
import VillamosTervezes from './components/VillamosTervezes';
import Rendezvények from './components/Rendezvények';
import ASZF from './components/ASZF';
import Adatvedelem from './components/Adatvedelem';
import CookieConsent from './components/CookieConsent';
import './App.css';

const Home = () => (
  <>
    <Hero />
    <Content />
    <Contact />
  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-dark">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/villanyszereles" element={<Villanyszereles />} />
            <Route path="/napelem" element={<Napelem />} />
            <Route path="/klima" element={<Klima />} />
            <Route path="/berendezesgyartas" element={<BerendezesGyartas />} />
            <Route path="/villamostervezes" element={<VillamosTervezes />} />
            <Route path="/rendezvenyek" element={<Rendezvények />} />
            <Route path="/aszf" element={<ASZF />} />
            <Route path="/adatvedelem" element={<Adatvedelem />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTop />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
